import { Typography } from '@mui/material';

import { PageWrapper } from '@/components/PageWrapper';

export function ProjectInfo() {
  return (
    <PageWrapper>
      <Typography>
        Das Projekt DatSim 2.0 – Digital Mobility Twin Munich hat das Ziel, den Status quo der Mobilität in der
        Metropolregion München sowie die Auswirkungen zukünftiger Maßnahmen digital abzubilden. Dadurch sollen fundierte
        Entscheidungen über deren Wirksamkeit und Sicherheit bereits vor ihrer Einführung getroffen werden können.
        <br />
        <br />
        Zu diesem Zweck werden einerseits Daten erhoben, um bestehende Verkehrs- und Mobilitätsdatensätze sowie zeitlich
        und räumlich hochaufgelöste Messungen von Luftqualitäts- und Verkehrsdaten zu sammeln und bereitzustellen.
        Andererseits ermöglicht eine Simulation die Modellierung des Verkehrs und seiner Emissionen bzw. Immissionen in
        der Metropolregion sowie die realitätsgetreue Abbildung ganzer Stadtteile. Mobilität wird somit doppelt gedacht
        – einmal physisch und einmal digital.
        <br />
        <br />
        Die beiden methodischen Schwerpunkte werden durch einen Use Case ergänzt: Gemeinsam mit kommunalen Stakeholdern
        untersuchen wir die Auswirkungen von Mobilitätsinterventionen auf die BOS-Einsatznavigation im städtischen
        Rettungswesen. Konkret entwickelt Trafficon hierfür situative Lenk- und Leitstrategien im Straßenraum für den
        Einsatzfall. Aktuell bestehende Routinganwendungen für das Rettungswesen vernachlässigen die Sonder- und
        Wegerechte von Einsatzfahrzeugen sowie das Expertenwissen und die Praxiserfahrung der Fahrzeugführenden, die
        jedoch für eine präzise Zeitabschätzung notwendig sind.
        <br />
        <br />
        Zudem realisiert Trafficon eine hochpräzise Routingumgebung, die auf den verfügbaren statischen und dynamischen
        Datengrundlagen sowie den zuvor entwickelten Lenk- und Leitstrategien basiert, um verbesserte Einsatzrouten im
        Untersuchungsgebiet zu erproben und zu evaluieren. Darüber hinaus erfolgt die Analyse und Bewertung der
        Routingergebnisse sowie deren Gegenüberstellung mit der Simulation und den EMS-Trajektorien entlang der vorab
        definierten Anwendungsfälle. Mithilfe der Evaluierung können im Strategiemanagement des Rettungswesens Maßnahmen
        zur Optimierung der Einsatzplanung und -navigation abgeleitet werden.
        <br />
        <br />
        Das Projekt ist Teil des &quot;Münchner Clusters für die Zukunft der Mobilität in Metropolregionen (MCube) -
        Clusters 4 Future Innovationsnetzwerke für unsere Zukunft&quot; und wird vom Bundesministerium für Bildung und
        Forschung gefördert.
      </Typography>
    </PageWrapper>
  );
}
